import styled from 'styled-components';
import { colors } from '@/presentation/reusables/constants';

const SFormPhoto = styled.div`
  width: 100%;
  padding: 24px 24px;
  margin: 16px 0 32px 0;
  background-color: ${colors.white};
  border-radius: 8px;
  box-shadow: 0px 2px 8px -4px rgba(176, 192, 202, 0.2);
`;

const SFormPhotoBody = styled.div`
  width: 100%;

  > button {
    &:nth-of-type(1) {
      margin-top: 12px;
    }

    &:nth-of-type(2) {
      margin-top: 24px;
    }
  }

  > div {
    &:nth-of-type(2) {
      margin-top: 16px;
    }
  }
`;

const SFormPhotoCaption = styled.div<{
  isInvalidSize?: boolean;
}>`
  border-radius: 4px;
  margin-bottom: 8px;
  overflow: hidden;

  > div {
    &:nth-of-type(1) {
      padding: 8px 8px;
      background-color: #eff1f6;

      > p {
        color: ${colors.text01};
        font-size: 12px;
        font-weight: 400;
        line-height: 16px;

        > b {
          color: ${colors.text02};
          font-weight: 700;

          > span {
            color: ${({ isInvalidSize }) =>
              isInvalidSize ? colors.error : colors.text02};
          }
        }
      }
    }
  }
`;

const SFormPhotoDropzone = styled.div<{
  isDrag: boolean;
}>`
  align-items: center;
  border-radius: 4px;
  border: 1px dashed ${colors.primary};
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 32px 8px;
  width: 100%;

  > input {
    display: none;
  }

  > p {
    color: ${({ isDrag }) => (isDrag ? '#1a055d' : colors.text01)};
    padding: 8px 0;
    text-align: center;
    font-size: 12px;
    line-height: 16px;
  }

  > img {
    height: 180px;
    width: 100%;
    object-fit: contain;
  }
`;

const SFormPhotoHeader = styled.div`
  margin-bottom: 16px;

  > p {
    color: ${colors.text02};

    &:nth-of-type(1) {
      font-size: 14px;
      font-weight: 700;
      line-height: 20px;
      margin-bottom: 8px;
    }

    &:nth-of-type(2) {
      font-size: 12px;
      font-weight: 400;
      line-height: 16px;
    }
  }
`;

export {
  SFormPhoto,
  SFormPhotoBody,
  SFormPhotoCaption,
  SFormPhotoDropzone,
  SFormPhotoHeader
};
